import React from "react";

const LOGO_COLOR = "https://customer-assets.emergentagent.com/job_manager-survival-kit/artifacts/pfcenx1y_ManageMeant-Excellence-RGB-Color-Tagline%20%281%29.png";
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_manager-survival-kit/artifacts/06vjgpg9_ManageMeant-Excellence-RBG-White-Tagline%20%281%29.png";

/**
 * Manage(Meant) Excellence official wordmark.
 * `variant`: "color" (default) or "white" for use on dark/teal backgrounds.
 * `size`: "sm" | "md" | "lg" — controls rendered height.
 */
export default function Wordmark({ variant = "color", size = "md" }) {
  const heightClass = {
    sm: "h-10 md:h-12",
    md: "h-14 md:h-16",
    lg: "h-20 md:h-24",
  }[size];

  const src = variant === "white" ? LOGO_WHITE : LOGO_COLOR;

  return (
    <img
      src={src}
      alt="Manage(Meant) Excellence"
      className={`${heightClass} w-auto block`}
      data-testid="wordmark"
    />
  );
}
